var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#share_svg__clip0)",
    fill: "#797584"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 10H2V3h2V1H1a1 1 0 00-1 1v9a1 1 0 001 1h9a1 1 0 001-1V7H9v3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7h2V6a2 2 0 012-2h1v2l3-3-3-3v2H8a4 4 0 00-4 4v1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "share_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}

export default SvgShare;